import { Col, OverlayTrigger, Popover, Row } from "react-bootstrap";

import {
  APPOINTMENT_STATUS_ALL,
  AppointmentStatus,
  getAppointmentStatusValues,
} from "../../../_constants/appointment";
import ColoredMarker from "./../../../common/components/ColoredMarker";
import SearchBarre from "../../../common/components/searchBarre/SearchBarre";

const AppointmentStatusToolbar = [
  APPOINTMENT_STATUS_ALL,
  ...Object.values(AppointmentStatus),
];

const OrdersDataGridToolbarComponent = ({
  loading,
  setActivePage,
  setStatuses,
  states,
  statuses,
}: any) => {
  let importRealEstate;
  //NE PAS SUPPRIMER LES COMMENTAIRES POUR LE MOMENT
  /* if (props.states.canImportRealEstate) {
    importRealEstate = (
      <Button
        className="archive-btn d-flex align-items-center justify-content-center w-100 flex-grow-1"
        variant="outline-primary"
      >
        <i style={{ fontSize: '18px' }} className="bi bi-upload me-2"></i>
        Importer mes biens
      </Button>
    );
  } */
  return (
    <div>
      <Row className=" align-items-center mb-2">
        <Col lg={7} md={10} className=" align-items-center d-flex mb-2">
          <SearchBarre
            disabled={loading}
            setSearchValue={(value) => {
              setActivePage(1);
              states.setInputFilter(value);
            }}
            placeholder="Rechercher le bien par adresse, bailleur ou nom de l’ancien locataire..."
          />
        </Col>

        <Col lg={{ span: 2, offset: 3 }} className=" align-items-center">
          <div className="d-flex justify-content-end mb-2 flex-grow-1">
            {importRealEstate}
          </div>
        </Col>
      </Row>
      <div className="d-flex justify-content-between flex-wrap pb-2">
        <div className="d-flex mb-2 ps-2 pe-2 bg-filters justify-content-center align-items-center flex-wrap ">
          {AppointmentStatusToolbar.map((status) => {
            const { color, hint, name } = getAppointmentStatusValues(status);
            return (
              <div key={name}>
                {hint !== undefined && (
                  <OverlayTrigger
                    trigger={["hover", "focus"]}
                    placement={"bottom"}
                    overlay={
                      <Popover id={`actionsComponentLink`}>
                        <Popover.Body className="p-0 m-2 popoverTextSecondary">
                          <strong>{hint}</strong>
                        </Popover.Body>
                      </Popover>
                    }
                  >
                    <div
                      className="mx-2"
                      style={{ cursor: "pointer" }}
                      onClick={() => setStatuses(name === "" ? [] : [name])}
                    >
                      <ColoredMarker
                        color={color}
                        active={
                          (statuses.length > 0 && statuses[0] === name) ||
                          (statuses.length === 0 && name === "")
                        }
                      >
                        {name !== "" ? name : "Tous"}
                      </ColoredMarker>
                    </div>
                  </OverlayTrigger>
                )}
                {hint === undefined && (
                  <div className="mx-2" style={{ cursor: "pointer" }}>
                    <ColoredMarker color={color}>
                      {name !== "" ? name : "Tous"}
                    </ColoredMarker>
                  </div>
                )}
              </div>
            );
          })}
        </div>

        {/*<div className="filter-prestations d-flex flex-md-row flex-wrap">*/}
        {/*  <div className="sortBy d-flex justify-content-center align-items-center">*/}
        {/*    <i className="bi bi-funnel me-1"></i> Filtrer par*/}
        {/*  </div>*/}
        {/*  <select*/}
        {/*      name="prestation"*/}
        {/*      className="div-filter ps-4"*/}
        {/*      //value={props.states.inputFilter}*/}
        {/*      //onChange={(e) => props.states.setPrestationFilter(e.target.value)}*/}
        {/*  >*/}
        {/*    {prestations.map((prestation) => (*/}
        {/*        <option key={prestation} value={prestation}>*/}
        {/*          {prestation}*/}
        {/*        </option>*/}
        {/*    ))}*/}
        {/*  </select>*/}
        {/*</div>*/}
      </div>
    </div>
  );
};

export default OrdersDataGridToolbarComponent;
